
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-storage-services",
      function () {
        return require("private-next-pages/home-storage-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-storage-services"])
      });
    }
  